import React from 'react';

import { TableData, TableRow } from 'shared-components/table';

const NoFinalisedInvestmentsFound = () => {
  return (
    <TableRow>
      <TableData className='bg-grey-300 pl-2' colSpan={10}>
        No Finalised Investments found
      </TableData>
    </TableRow>
  );
};

export default NoFinalisedInvestmentsFound;
